// extracted by mini-css-extract-plugin
module.exports = {"wrapper_style":"PageWrapper-module__wrapper_style___17AdU"};